export enum WarehouseStatusCode {
  REQUESTING_TO_RECEIVE = 'RequestingToReceive',
  IN_STORAGE = 'InStorage',
  REQUESTING_TO_DISPATCH = 'RequestingToDispatch',
  OUT_OF_WAREHOUSE = 'OutOfWarehouse',
  REQUESTING_DISPOSAL = 'RequestingDisposal',
  DISPOSED = 'Disposed',
  NOT_RECEIVED = 'NotReceived',
  REQUESTING_SCAN = 'RequestingScan',
}

export enum DeliveryTime {
  NO_SPECIFIC_TIME = '90', // 時間指定なし
  MORNING = '91', // 午前
  AFTERNOON = '92', // 午後
  EVENING = '93', // 夕方
}

export const wareHouseRecords: Record<WarehouseStatusCode, string> = {
  [WarehouseStatusCode.NOT_RECEIVED]: '未入庫',
  [WarehouseStatusCode.REQUESTING_TO_RECEIVE]: '入庫依頼中',
  [WarehouseStatusCode.IN_STORAGE]: '保管中',
  [WarehouseStatusCode.REQUESTING_SCAN]: 'スキャン依頼中',
  [WarehouseStatusCode.REQUESTING_TO_DISPATCH]: '出庫依頼中',
  [WarehouseStatusCode.OUT_OF_WAREHOUSE]: '出庫済',
  [WarehouseStatusCode.REQUESTING_DISPOSAL]: '廃棄依頼中',
  [WarehouseStatusCode.DISPOSED]: '廃棄済',
};
